export default __webpack_public_path__ + "static/media/82.e601b014.jpeg";